import { ClienteSalvaSchermo } from "./ClienteSalvaSchermo";
import { Settings, X, Share2, Type } from "lucide-react";

const Group = ({ title, children, testid }) => (
  <div className="space-y-2" data-testid={testid}>
    <h3 className="text-xs font-bold uppercase tracking-wide text-slate-400">{title}</h3>
    {children}
  </div>
);

// Pannello ⚙️ Impostazioni della Vista Cliente (aperto dall'ingranaggio nell'header).
// Raggruppa le impostazioni: usabilità (dimensione testo), condivisione, presentazione (Modalità Schermo,
// solo Pro) e, SOLO in anteprima staff/installatore, le impostazioni installatore (Versione Pro, avvisi, link).
export function ClienteImpostazioni({ src, imp, grande, setGrande, staff, onShare, onClose, reload }) {
  const seg = (on) => `flex-1 rounded-lg px-3 py-2 text-sm font-bold transition-colors ${on ? "bg-white text-sky-700 shadow-sm" : "text-slate-500"}`;
  return (
    <div className="fixed inset-0 z-[60] flex items-end justify-center bg-black/40 sm:items-center sm:p-4" onClick={onClose} data-testid="cliente-impostazioni">
      <div className="cliente-font flex max-h-[92dvh] w-full max-w-lg flex-col overflow-hidden rounded-t-3xl bg-white sm:max-h-[85vh] sm:rounded-3xl" onClick={(e) => e.stopPropagation()}>
        <div className="flex shrink-0 items-center justify-between border-b border-slate-100 p-4">
          <h2 className="flex items-center gap-2 text-lg font-extrabold text-slate-900"><Settings className="h-5 w-5 text-sky-600" />Impostazioni</h2>
          <button onClick={onClose} className="rounded-full p-1.5 text-slate-400 transition-colors hover:text-slate-700" aria-label="Chiudi" data-testid="cliente-impostazioni-close"><X className="h-5 w-5" /></button>
        </div>
        <div className="min-h-0 flex-1 space-y-5 overflow-y-auto overscroll-contain p-4" data-testid="cliente-impostazioni-body">
          <Group title="Usabilità" testid="impost-usabilita">
            <div className="rounded-2xl bg-slate-50 p-3">
              <div className="mb-2 flex items-center gap-2 text-sm font-semibold text-slate-700"><Type className="h-4 w-4 text-sky-600" />Dimensione testo</div>
              <div className="flex gap-1 rounded-xl bg-slate-200/60 p-1">
                <button type="button" className={seg(!grande)} onClick={() => setGrande(false)} data-testid="impost-testo-normale">Normale</button>
                <button type="button" className={seg(grande)} onClick={() => setGrande(true)} data-testid="impost-testo-grande">Grande</button>
              </div>
              <p className="mt-1.5 text-[11px] text-slate-400">Ingrandisce tutta la Vista Cliente: utile su TV o per una lettura più comoda.</p>
            </div>
          </Group>

          <Group title="Condivisione" testid="impost-condivisione">
            <button type="button" onClick={() => { onClose(); onShare(); }} data-testid="impost-condividi"
              className="flex w-full items-center justify-center gap-2 rounded-xl bg-sky-600 px-4 py-3 text-sm font-bold text-white transition-colors hover:bg-sky-700">
              <Share2 className="h-4 w-4" />Condividi il tuo impianto
            </button>
            <p className="text-[11px] text-slate-400">Crea un link da inviare: resta visibile per 24 ore.</p>
          </Group>

          {imp.pro && src.logoUp && (
            <Group title="Presentazione · Modalità Schermo" testid="impost-presentazione">
              <ClienteSalvaSchermo src={src} hasLogo={!!imp.cliente_logo} hasVideo={!!imp.cliente_video} nome={imp.nome} logoUrl={imp.cliente_logo} logoBg={imp.cliente_logo_bg} videoUrl={src.videoUrl} bollettinoAuto={imp.bollettino_auto} onChange={reload} />
            </Group>
          )}

          {staff && (
            <Group title="Impostazioni installatore" testid="impost-installatore">
              {staff}
            </Group>
          )}
        </div>
      </div>
    </div>
  );
}
